/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import allActions from "../../../Store/action";
import Ilustration from "../../../assets/img/onboarding-last-step.svg";

const Success = ({
  setStep,
  user,
  questions,
  questionnaireState,
  taxpro_allow_appointments,
  isAppointmentBooked,
  license,
  isMessageSent,
  isVerify,
  isPdfDownloaded,
}) => {
  const dispatch = useDispatch();
  
  const [allCompleted, setAllCompleted] = useState(false);


  useEffect(() => {
    dispatch(
      allActions.user.ReGetUserData(() =>
        dispatch(allActions.dashboard.getAccountStatus())
      )
    );
  }, []);

  useEffect(() => {
    const {
      isOnboardingVideoSeen,
      isPasswordChanged,
      firstMessageSent,
      isPdfDownloaded,
    } = user?.settings || {};
    const isReady =
      isOnboardingVideoSeen &&
      isPasswordChanged &&
      user?.isVerify &&
      isAppointmentBooked &&
      user?.lead?.[0]?.driver_license &&
      questionnaireState?.value === questionnaireState?.max &&
      isPdfDownloaded &&
      firstMessageSent
    if (isReady) {
      setAllCompleted(true);
    } else {
      setAllCompleted(false);
    }
  }, [
     user
  ]);

  const handleBack = () => {
      if (!isPdfDownloaded) {
      setStep(8);
      return;
    }

    if (!isMessageSent) {
      setStep(7);
      return;
    }

    if (questionnaireState?.value !== questionnaireState?.max) {
      setStep(6);
      return;
    }

    if (!license) {
      setStep(5);
      return;
    }

    if (taxpro_allow_appointments && !isAppointmentBooked) {
      setStep(4);
      return;
    }

    if (!isVerify) {
      setStep(3);
      return;
    }

    if (!user?.settings?.isPasswordChanged) {
      setStep(2);
      return;
    }

    setStep(1);
  };

  return (
    <div className="d-flex flex-column justify-content-start align-items-center text-center bg-white px-3 ">
      {allCompleted ? (
        <>
          <img src={Ilustration} alt="Success" />

          <h4 className="fw-bold mb-2 text-primary mt-3">Congratulations!</h4>

          <h5 className="fw-semibold text-dark mb-2 fs-3">
            You finished the onboarding process
          </h5>

        {user?.settings?.newUser ? <>
          <p className="mb-2 fs-4">
            Here's your <span className="fw-bold text-success">$100 Off</span>
          </p>

          <p className="mb-4">Go ahead. You've earned it.</p></> : ''}
        </>
      ) : (
        <>
          <h4 className="fw-semibold text-danger mb-3 fs-5">
            You have not yet finished all the steps.
          </h4>
          {user?.settings?.newUser ? (
            <p className="text-muted mb-4 fs-5" style={{ maxWidth: "500px" }}>
              Go back to complete your onboarding and claim your{" "}
              <span className="fw-bold text-success">$100 Off</span> your first
              tax service.
            </p>
          ) : (
            <p className="text-muted mb-4 fs-5" style={{ maxWidth: "500px" }}>
              Go back to complete your onboarding steps and make sure nothing’s
              missed
            </p>
          )}
        </>
      )}
      <div className="d-flex justify-content-center align-items-center gap-3 w-100">
        {!allCompleted ? (
          <button
            className="btn btn-outline-primary btn-sm px-5 py-2"
            onClick={handleBack}
          >
            Back
          </button>
        ) : (
          <button
            className="btn btn-primary btn-sm px-5 py-2 mt-3"
            onClick={() => {
              document.getElementById("showOnboardingVideo").click();
              localStorage.setItem("onboarding_step", 1);
              dispatch(
                allActions.user.ReGetUserData(() =>
                  dispatch(allActions.dashboard.getAccountStatus())
                )
              );
            }}
          >
            Finish
          </button>
        )}
      </div>
    </div>
  );
};

export default Success;
